import { Tools } from "../../../utilities/Tools";

const viewBodyHeaderTpl = (settings, viewBodyHeaderData, resource) => {
  let html = ``;

  // Ustawienie parametrów dla siatki (grid) css.
  let grid = (() => {
    if (viewBodyHeaderData.has("year")) {
      return {
        type: "year",
        templateColumnsRepeat: (() => {
          let columns = 0;

          for (const value of viewBodyHeaderData.get("year").data.values()) {
            columns = columns + value.hour;
          }

          return columns;
        })(),
      };
    }

    if (viewBodyHeaderData.has("month")) {
      return {
        type: "month",
        templateColumnsRepeat: (() => {
          let columns = 0;

          for (const value of viewBodyHeaderData.get("month").data.values()) {
            columns = columns + value.hour;
          }

          return columns;
        })(),
      };
    }

    if (viewBodyHeaderData.has("weekday")) {
      return {
        type: "weekday",
        templateColumnsRepeat: (() => {
          let columns = 0;

          for (const value of viewBodyHeaderData.get("weekday").data.values()) {
            columns = columns + value.hour;
          }

          return columns;
        })(),
      };
    }

    if (viewBodyHeaderData.has("hour")) {
      return {
        type: "hour",
        templateColumnsRepeat: viewBodyHeaderData.get("hour").data.length,
      };
    }

    return {};
  })();

  // Renerowanie widoku nagłówka.
  if (viewBodyHeaderData.size > 0) {
    let gridTemplateColumnsMin = resource.slotWidth;

    html += `
        <ul class="projects-calendar__body-header-grid" style="grid-template-columns: repeat(${
          grid.templateColumnsRepeat
        }, minmax(${gridTemplateColumnsMin}px, 1fr))">
            ${(() => {
              let html = ``;

              viewBodyHeaderData.forEach((row, key) => {
                switch (key) {
                  case "year":
                  case "month":
                  case "weekday":
                    html += `${(({ data, format }) => {
                      let html = ``;
                      let gridColumnStart = 1;

                      data.forEach((object) => {
                        let gridColumnEnd = object.hour;
                        let style = Tools.getStyleAttribute({
                          "grid-column": `${gridColumnStart} / span ${gridColumnEnd}`,
                        });

                        html += `<li class="${key}" ${style}><span>${object.date.toLocaleString(
                          "pl-PL",
                          format
                        )}</span></li>`;

                        gridColumnStart = gridColumnStart + gridColumnEnd;
                      });

                      return html;
                    })(row)}`;
                    break;

                  case "hour":
                    html += `${(({ data, format }) => {
                      return data
                        .map((hour) => {
                          return `<li class="hour"><span>${hour.toLocaleString("pl-PL", format)}</span></li>`;
                        })
                        .join("");
                    })(row)}`;

                    break;

                  default:
                    break;
                }
              });

              //
              return html;
            })()}
        </ul>`;
  }

  return html;
};

export { viewBodyHeaderTpl };
